import React from 'react';
import { ReactSVG } from 'react-svg';
import { useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { textSizes } from '../../config/config';
import { cn } from '../../utils/utils';
import Loader from './Loader';
import { useWindowWidth } from '../../utils/helpers';
import ViewReverse from '../ViewReverse';

const Button = ({ text, weight, className, onClick, textSize, isDisabled = false, icon, iconClassName = '', loading, loaderClasses }) => {
  const { TextWeight } = dynamicfunction();
  const width = useWindowWidth();

  const fontsize = useSelector((state) => state.content?.fontsize);

  const getSize = () => {
    if (fontsize === textSizes.small) {
      return textSize ? Number(textSize) - 2 : width > 640 ? 10 : 7;
    } else if (fontsize === textSizes.medium) {
      return textSize ? Number(textSize) : width > 640 ? 12 : 9;
    } else if (fontsize === textSizes.large) {
      return textSize ? Number(textSize) + 2 : width > 640 ? 14 : 12;
    }
  };

  return (
    <button
      style={{
        fontSize: getSize(),
      }}
      type='button'
      className={cn(
        'py-2 px-6 flex min-w-fit justify-center min-h-[2.2rem] items-center gap-2 rounded-lg bg-orange border border-orange text-white',
        isDisabled ? 'opacity-50 cursor-not-allowed' : 'opacity-100',
        weight ? weight : TextWeight.regular,
        className
      )}
      onClick={isDisabled ? null : onClick}
      disabled={isDisabled || loading}
    >
      {loading ? (
        <Loader className={cn('!w-4 !h-4 !border-2 border-white', loaderClasses)}/>
      ) : (
        <ViewReverse className={'w-full items-center justify-center gap-2'}>
          {icon && <ReactSVG src={icon} className={iconClassName} />}
          {text}
        </ViewReverse>
      )}
    </button>
  );
};

export default Button;
